export default __webpack_public_path__ + "9b485011d68f90860cbde8878a4bf693.svg";